<template>
  <CRow>
    <CCol sm="12">
      <CCard>
        <CCardHeader>
          <CIcon name="cil-cloud" />
          <h5 class="d-inline ml-2">DNS Management</h5>
        </CCardHeader>
        <BackendTable />
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import BackendTable from "./BackendTable";

export default {
  name: "DnsManagement",
  components: {
    BackendTable,
  },
};
</script>
